<template>
	<div class="page_warp">
		<div v-if="!isAdd && !isEdit && !isDetail" class="menuManagemen">
			<div class="top_content">
				<div class="top_input">
					<el-input v-model="searchWord" placeholder="请输入"></el-input>
				</div>
				<div class="search_btn" @click="getData">查询</div>
				<div class="add_btn" @click="add" v-if="permissionItem.add">添加</div>
			</div>
			<div class="bottom_content">
				<div class="table_container" v-bind:id="tableId">
					<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
						v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
						<!-- <el-table-column prop="vehId" label="车辆ID"></el-table-column> -->
						<el-table-column fixed width="120" prop="vehId" label="ID"></el-table-column>
						<el-table-column fixed width="120" prop="vehNo" label="牵引车车牌号"></el-table-column>
						<el-table-column width="150" prop="drivingLicense.vedlFrameNo" label="车辆识别号（VIN）"></el-table-column>
						<el-table-column width="120" prop="vehAffOrgName" label="所属公司"></el-table-column>
						<el-table-column width="120" prop="vehSource" label="车辆来源">
							<template #default="scope">
								<span v-if="scope.row.vehSource == '0'">自有</span>
								<span v-else-if="scope.row.vehSource == '1'">外调</span>
								<span v-else-if="scope.row.vehSource == '2'">临时</span>
								<span v-else>--</span>
							</template>
						</el-table-column>
						<el-table-column width="100" prop="vehStatus" label="车辆状态">
							<template #default="scope">
								<el-switch :value="scope.row.vehStatusBoolen" active-text="正常" inactive-text="禁用"
									@change="updateState(scope.row)">
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column width="180" prop="drivingLicense.vedlExpirationDate"
							label="行驶证到期检验时间"></el-table-column>
						<el-table-column width="180" prop="drivingLicense.vedlScrappingDate"
							label="强制报废时间"></el-table-column>
						<el-table-column width="180" prop="sxveinEndDate" label="商业险截止时间"></el-table-column>
						<el-table-column width="200" prop="operationCertificate.veocExpirationDate"
							label="道路运输证截止时间"></el-table-column>
						<el-table-column width="200" prop="qualificationCertificate.veqcAirBottleChkdate"
							label="气瓶下次检验时间"></el-table-column>
						<el-table-column width="200" prop="qualificationCertificate.veqcPreGaugeChkdate"
							label="压力表有效截止时间"></el-table-column>
						<el-table-column width="200" prop="qualificationCertificate.veqcSafValveChkdate"
							label="安全阀下次检验时间"></el-table-column>
						<el-table-column width="200" prop="vehCretime" label="创建时间"></el-table-column>
						<el-table-column width="100" fixed="right" label="操作">
							<template #default="scope">
								<span v-if="permissionItem.edit||permissionItem.list" class="default_color pointer m-right10"
									v-on:click="edit(scope.row.vehId)">编辑</span>
								<!-- <span class="default_color pointer m-right10"
									v-on:click="detail(scope.row.vehId)">详情</span> -->
								<span v-if="permissionItem.del" class="col-FF1A1A pointer" v-on:click="del(scope.row.vehId)">删除</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="flex flex-y-center flex-x-center">
					<el-config-provider :locale="locale">
						<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
							:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
							:total="totalCount" @size-change="getData" @current-change="getData" />
					</el-config-provider>
				</div>
			</div>
		</div>
		<!--    <Add ref="addRef" v-if="isAdd" @getData="getData" />
    <Edit ref="editRef" v-if="isEdit" @getData="getData" />
    <Detail ref="detailRef" v-if="isDetail" @getData="getData" /> -->

		<div class="menuManagemen" v-if="isAdd">
			<Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
		</div>
		<div class="menuManagemen" v-if="isEdit">
			<Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
		</div>
		<div class="menuManagemen" v-if="isDetail">
			<Detail :sendData="sendData" @closeModal="closeModal" @getData="getData" />
		</div>
	</div>

</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "tractionVehicle",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "roleManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				isDel: false,
				sendData: null,
				locale: zhCn,
				
				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "tractionVehicle:list") {
						data.permissionItem.list = true;
					}
					if (el == "tractionVehicle:add") {
						data.permissionItem.add = true;
					}
					if (el == "tractionVehicle:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "tractionVehicle:del") {
						data.permissionItem.del = true;
					}
				});
				
				console.log(store.state.userInfo);

				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询牵引车辆列表权限！");
					return;
				}
				
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					vehType: 1,
					// roleOrg: store.state.userInfo.orgId,
				};
				const r = await proxy.$http.get(apiObj.vehList, params);
				console.log(r);
				if (r.code === 0) {
					r.rows.forEach((el) => {
						el.vehStatusBoolen = el.vehStatus == 0 ? true : false;

						el.insuranceList.forEach((item) => {
							if (item.veinFlag == "0") {
								el.qxveinEndDate = item.veinEndDate; //强险
							} else if (item.veinFlag == "1") {
								el.sxveinEndDate = item.veinEndDate; //商业险
							}
						});
					});
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};

			// 添加 根目录
			const add = () => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有牵引车辆添加权限！");
					return;
				}
				
				data.isAdd = true;
			};

			// 菜单编辑
			const edit = (id) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有牵引车辆编辑权限！");
					return;
				}
				
				data.sendData = {
					vehId: id,
				};
				data.isEdit = true;
			};
			// 菜单详情
			const detail = (id) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有牵引车辆查询权限！");
					return;
				}
				
				data.sendData = {
					vehId: id,
				};
				data.isDetail = true;
			};
			//菜单删除
			const del = (id) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有牵引车辆删除权限！");
					return;
				}

				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							vehId: id,
						};
						const r = await proxy.$http.postFormData(apiObj.vehDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const updateState = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有牵引车辆编辑权限！");
					return;
				}
				
				proxy.$confirm(
					`您确定执行${!row.vehStatusBoolen ? "启用" : "禁用"}操作，是否继续?`,
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					proxy.$http
						.postFormData(
							"/biz/bdzl/vehInfo/updateStatus", {
								vehId: row.vehId,
								status: row.vehStatusBoolen ? 1 : 0
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
								getData();
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			//关闭
			const closeModal = () => {
				data.isAdd = false;
				data.isEdit = false;
				data.isDetail = false;
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				closeModal,
				updateState,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.menuManagemen_warp {
		width: 100%;
		height: 100%;
	}

	.menuManagemen {
		width: 100%;
		height: 100%;

	}
</style>